module.exports = __webpack_public_path__ + "img/timesheet.1a39f423.png";